import { graphql } from '../../gql';

export const GET_TERMS_AND_CONDITIONS_QUERY = graphql(`
  query GetTermsAndConditions {
    termsAndConditions {
      content
      createdAt
      version
    }
  }
`);

// export const ACCEPT_TERMS_AND_CONDITIONS_MUTATION = graphql(`
//   mutation AcceptTermsA($version: String!) {
//     acceptTerms(version: $version) {
//       id
//       terms {
//         version
//         status
//         termsAndConditions {
//           version
//           createdAt
//         }
//       }
//     }
//   }
// `);

